/**
 * Vue2 中 base64 转换为 File 对象
 * @param {String} base64Str 完整的base64字符串（必须包含 data:image/xxx;base64, 前缀）
 * @param {String} [fileName] 自定义文件名（可选，默认：image_时间戳.后缀）
 * @returns {File} 转换后的 File 对象
 * @throws {Error} 格式错误时抛出异常
 */
export function base64ToFile(base64Str, fileName) {
  try {
    // 1. 严格校验 base64 格式（必须以 data:image/ 开头）
    if (!base64Str || typeof base64Str !== "string") {
      throw new Error("传入的base64字符串不能为空，且必须为字符串类型");
    }
    if (!base64Str.startsWith("data:image/")) {
      throw new Error(
        '无效的base64格式！必须包含 "data:image/xxx;base64," 前缀（如 data:image/png;base64,xxxx）',
      );
    }

    // 2. 拆分 base64 头（含mime类型）和内容部分
    const [base64Header, base64Content] = base64Str.split(",");
    if (!base64Content) {
      throw new Error(
        "base64字符串格式错误，缺少内容部分（逗号分隔后无有效内容）",
      );
    }

    // 3. 提取图片 MIME 类型（如 image/png、image/jpeg、image/webp）
    const mimeMatch = base64Header.match(/:(.*?);/);
    const mimeType = mimeMatch ? mimeMatch[1] : "image/png"; // 兜底为png

    // 4. 提取图片后缀（用于自动生成文件名）
    const ext = mimeType.split("/")[1] || "png";

    // 5. 处理文件名（自定义 > 自动生成）
    const finalFileName = fileName || `image_${Date.now()}.${ext}`;

    // 6. 解码 base64 内容为二进制数据
    const bstr = atob(base64Content); // 解码base64
    let n = bstr.length;
    const u8Arr = new Uint8Array(n); // 创建8位无符号整数数组
    while (n--) {
      u8Arr[n] = bstr.charCodeAt(n); // 转换为二进制编码
    }

    // 7. 生成 File 对象（核心：兼容 FormData 上传）
    return new File([u8Arr], finalFileName, { type: mimeType });
  } catch (error) {
    console.error("base64转File失败：", error.message);
    throw error; // 抛出异常，让调用方处理
  }
}

/**
 * （可选）base64 转换为 Blob 对象（轻量版，无文件名，适合临时使用）
 * @param {String} base64Str 完整的base64字符串
 * @returns {Blob} Blob 对象
 */
export function base64ToBlob(base64Str) {
  const [base64Header, base64Content] = base64Str.split(",");
  const mimeType = base64Header.match(/:(.*?);/)[1];
  const bstr = atob(base64Content);
  let n = bstr.length;
  const u8Arr = new Uint8Array(n);
  while (n--) {
    u8Arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8Arr], { type: mimeType });
}



// WEBPACK FOOTER //
// ./src/utils/fileConvert.js